import React, { forwardRef } from 'react';
import { Inbox } from 'lucide-react';
import { cx } from '../utils';
import './EmptyState.css';

// icon berilmasa Inbox ikonkasi ishlatiladi; icon={null} — ikonkasiz.
const EmptyState = forwardRef(function EmptyState(
  { icon = <Inbox />, title, description, action, className, ...rest },
  ref
) {
  return (
    <div {...rest} ref={ref} className={cx('ui-empty', className)}>
      {icon && (
        <span className="ui-empty__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      {title && <p className="ui-empty__title">{title}</p>}
      {description && <p className="ui-empty__description">{description}</p>}
      {action && <div className="ui-empty__action">{action}</div>}
    </div>
  );
});

export default EmptyState;
